/**
 * SectionGroupNode — Visual group container for interview sections.
 * Transparent background with labeled header and dashed border.
 */

import type { NodeProps } from '@xyflow/react';

interface SectionGroupData extends Record<string, unknown> {
  label: string;
}

export function SectionGroupNode({ data }: NodeProps) {
  const d = data as unknown as SectionGroupData;

  return (
    <div className="min-h-[100px] min-w-[200px] rounded-2xl border-2 border-dashed border-border/50 bg-muted/10 p-2">
      <div className="mb-2 rounded-lg bg-card/80 px-3 py-1.5 shadow-sm">
        <p className="text-[11px] font-semibold text-foreground/70">{d.label}</p>
      </div>
    </div>
  );
}
